import {
  Button,
  Stack,
  TextField,
  Typography,
  Box,

} from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';
import TextareaEditor from 'common/Editor';

import { TitlesWrapper, VisibleWrapper, StyledFormHelperText } from './styled';
import { useTeamLogic } from './useTeamLogic';
import ImagesContainer from './components/Images';

const CreateTeam = () => {
  const {
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    largeImageMessage,
    watch,
    setValue,
    setError,
    setFlowProcess,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
    handleDeleteImage,
  } = useTeamLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Team' : 'Create New Team Member'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('nameAm')}
            label="Name Am"
            error={!!errors.nameAm}
            helperText={errors.nameAm ? 'Name is required' : ''}
          />
          <TextField
            {...register('nameEn')}
            label="Name En"
            error={!!errors.nameEn}
            helperText={errors.nameEn ? 'Name is required' : ''}
          />
          <TextField
            {...register('nameRu')}
            label="Name Ru"
            error={!!errors.nameRu}
            helperText={errors.nameRu ? 'Name is required' : ''}
          />
          <TextField
            {...register('positionAm')}
            label="Position Am"
            error={!!errors.positionAm}
            helperText={errors.positionAm ? 'Position is required' : ''}
          />
          <TextField
            {...register('positionEn')}
            label="Position En"
            error={!!errors.positionEn}
            helperText={errors.positionEn ? 'Position is required' : ''}
          />

          <TextField
            {...register('positionRu')}
            label="Position Ru"
            error={!!errors.positionRu}
            helperText={errors.positionRu ? 'Position is required' : ''}
          />
        </TitlesWrapper>

        <ImagesContainer
          keyUploadedFileList="uploadedFileList"
          keyMainImageUrl="mainImageUrl"
          keyExistingImages="existingImages"
          buttonText="Upload Images"
          setValue={setValue}
          multiple={false}
          posibilityToMainImage={false}
          handleDeleteImage={handleDeleteImage}
          isImageViewOpen={isImageViewOpen}
          imageSrcForAction={imageSrcForAction}
          setFlowProcess={setFlowProcess}
          onChangeUpload={onChangeUpload}
        />

        <VisibleWrapper>
          <Box>
            <Typography>
              Visibility in website
            </Typography>
            <Box>
              <Radio label="Yes" name="visible" canBe />
              <Radio label="No" name="visible" canBe={false} />
            </Box>
          </Box>

        </VisibleWrapper>

        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default CreateTeam;
